import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import access from './access';
import airportServices from './airportServices';
import alert from './alert';
import checkLists from './checkList';
import crew from './crew';
import defects from './defects';
import documents from './documents';
import { filterReducer } from './filter';
import flightPage from './flightPage';
import gps from './gps';
import images from './images';
import library from './library';
import linearLoading from './linearLoading';
import login from './login';
import messageDialog from './messageDialog';
import messenger from './messenger';
import { modalReducer } from './modal';
import navigation from './navigation';
import notices from './notices';
import { notificationsReducer } from './notifications';
import { online } from './online';
import partitions from './partitions';
import progressIndicator from './progressIndicator';
import reports from './reports';
import restoreFiles from './restoreFiles';
import routesDeclaration from './routesDeclaration';
import screen from './screen';
import sendedData from './sended-data';
import { shortcuts } from './shortcuts';
import storeStage from './storeStage';
import { systemOfMeasurement } from './systemOfMeasurement';
import tasks from './tasks';
import telex from './telex';
import textDialog from './textDialog';
import users from './users';
import version from './version';
import wizard from './wizard';

const createRootReducer = (history) =>
    combineReducers({
        alert,
        screen,
        sendedData,
        gps,
        restoreFiles,
        login,
        tasks,
        library,
        users,
        crew,
        documents,
        defects,
        telex,
        notices,
        routesDeclaration,
        version,
        reports,
        storeStage,
        textDialog,
        filter: filterReducer,
        router: connectRouter(history),
        wizard,
        navigation,
        notifications: notificationsReducer,
        images,
        modal: modalReducer,
        progressIndicator,
        messageDialog,
        linearLoading,
        flightPage,
        systemOfMeasurement,
        online,
        checkLists,
        access,
        airportServices,
        partitions,
        shortcuts,
        messenger,
    });

export { createRootReducer };
